export enum ColorPalette {
  statusChangeBlackText = '#09B411',
  statusChangeWhiteText = '#2C6C2F',
  situationChangeBlackText = '#CECECE',
  situationChangeWhiteText = '#303032',
  settingsBlackText = '#FA00FF',
  settingsWhiteText = '#CF32A5',
  workflowBlackText = '#FF004C',
  workflowWhiteText = '#E50044',
  navigationBlackText = '#3D93FF',
  navigationWhiteText = '#006BFF',
  blackText = '#303032',
  whiteText = '#FFFFFF',
  paragraphText = '#646E82',
  naplesYellow = '#FFDE69',
  colorSupportDarkGrey = '#3B3B3D',
  colorSupportLightGrey = '#F7F8FA',
  colorSupportMediumGrey = '#DDE5ED',
  sanJuan = '#45586B',
  cyanBlueInputBorder = '#ABBED1',
  _CCE1FF = '#CCE1FF',
  _B0D1FF = '#B0D1FF',
  _D4D4D4 = '#D4D4D4',
  _9B9B9B = '#9B9B9B',
  _006BFF = '#006BFF',
  focusBorderColor = '#ABBED1',
  white = '#FFFFFF',
  _001533 = '#001533',
  _004099 = '#004099',
  level_1 = '#001533',
  level_2 = '#004099',
  level_3 = '#006BFF',
  _B7BECD = '#B7BECD',
  _C7DEFF = '#C7DEFF',
  Black_0_5 = '#303032',
  Gray_0_3 = '#ABBED1',
  LightGray_0_1_5 = '#F7F8FA'
}

export enum ColorPaletteToggleButton {
  rectangleBackgroundColorChecked = ColorPalette._B0D1FF,
  rectangleBackgroundColorUnChecked = ColorPalette._D4D4D4,
  circleBackgroundColorChecked = ColorPalette._006BFF,
  circleBackgroundColorUnChecked = ColorPalette._9B9B9B
}

export enum ColorPaletteFeedbackCard {
  default = '#ABBED1',
  success = '#74EC81',
  warning = '#FFDE69',
  error = '#FF7373'
}

export enum ColorPaletteMouseOver {
  default = '#ABBED1',
  success = '#74EC81',
  warning = '#FFDE69',
  error = '#FF7373'
}

export enum ColorPaletteAlertBanner {
  default = '#ABBED1',
  success = '#74EC81',
  warning = '#FFDE69',
  error = '#FF7373'
}

export enum ColorPaletteCES {
  CESprimary = '#0071FF',
  CESgray = '#646E82',
  CESwhite = ColorPalette.white
}

export default ColorPalette
